import { Card, Row, Col, Dropdown } from 'react-bootstrap'
import EditModal from './crudModals/EditModal'
import DeleteModal from './crudModals/DeleteModal'
import { useSelector } from 'react-redux'

export default function AnnouncementsCard({ announcement, getAnnouncements }) {
  const { user: authUser } = useSelector(x => x.auth)
  return (
    <Col xs={12} md={12} lg={12} className='mt-2 mb-2'>
      <Card className="roles-card">
        <Card.Header className="roles-card-header">
          <Row>
            <Col xs={12} md={12} lg={12}>
              <h2>{announcement.title}</h2>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col xs={12} md={12} lg={12}>
              <h5>To: {announcement.to}{announcement.to !== 'Public' && 's'}</h5>
            </Col>
          </Row>
          <Row className='short-description mt-3 mb-3'>
            <Col xs={12} md={12} lg={12}>
              {/* <h5>{announcement.shortDescription}</h5> */}
              <div dangerouslySetInnerHTML={{ __html: announcement.shortDescription }}></div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12} lg={12}>
              <div dangerouslySetInnerHTML={{ __html: announcement.description }}></div>
            </Col>
          </Row>

        </Card.Body>
        <Card.Footer>
          {authUser?.user.acl === "Officer" &&
            <Dropdown className="roles-card-dropdown" data-bs-theme={'dark'}>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                Actions
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <EditModal announcement={announcement} getAnnouncements={getAnnouncements} />
                <DeleteModal announcement={announcement} getAnnouncements={getAnnouncements} />
              </Dropdown.Menu>
            </Dropdown>
          }

        </Card.Footer>
      </Card>
    </Col>
  )
}